<div class="payment_bdy">
  <div class="table_content  mt-xl-3 mt-lg-3 mt-md-3" *ngIf="!showExport">
    <div class="row px-xl-4 px-lg-4 px-md-4 py-4" [class.pt-3]="matchUrl('paypal-transactions')">
      <div class="col-lg-4 col-xl-4 col-md-12 col-sm-12 col-12 form-group has-search mb-0">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="search" class="form-control search-bar col-xl-12 col-lg-12 col-md-12 col-12 py-2"
               [(ngModel)]="searchText" (input)="searchHits.next()"
               placeholder="Search"/>
      </div>
      <div class="col-lg-7 col-xl-6 col-md-12 col-sm-9 col-8 mb-md-2 mob_calendar mb-xl-0 mb-lg-0">
        <div class="row">
          <input type="text" [(ngModel)]="from_date"
                 class="form-control calander-input-icon col-xl-4 col-md-5 col-md-5 col-md-5 col-4 ml-md-3 mr-xl-3 mr-m-7"
                 [matDatepicker]="dp" [max]="today" placeholder="From" (click)="dp.open()"
                 (dateChange)="checkdate();">
          <mat-datepicker #dp (closed)="datereport();"></mat-datepicker>
          <input type="text" [(ngModel)]="to_date"
                 class="form-control calander-input-icon col-xl-4 col-md-6 col-md-6 col-md-6 col-4 mob_text"
                 [matDatepicker]="dp1" placeholder="To" [max]="today" (click)="dp1.open()"
                 (dateChange)="checkdate2();">
          <mat-datepicker #dp1 (closed)="datereport();"></mat-datepicker>
        </div>
      </div>
      <div class="col-lg-3 col-xl-2 col-md-12 col-sm-3 col-4 text-right">

        <button class="export_btn" (click)="openexcel()">Export</button>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 px-m-0">
        <div  (scroll)='scrollcontent("TopScroll", "scrollContent")' *ngIf="!loadFlag"  class="top-scroll" id="TopScroll">
          <img src="" height=1 [style]="checkTablewidth()">
        </div>
        <div class="table-responsive table-height" (scroll)='scrollcontent("scrollContent", "TopScroll")' id="scrollContent">
          <app-message-on-list *ngIf="!loadFlag && errorMsg" [message]="errorMsg" [iconName]="'warning'"></app-message-on-list>
          <table *ngIf="!errorMsg" class="table mb-0" id="table-width">
            <thead>
            <tr>
              <th>
                <a (click)="setSorting('amount')">Amount
                  <i class="fa fa-thin" [ngClass]="orderBy === 'amount' ? stylesortBy : 'fa-angle-down'"></i>
                </a>
              </th>
              <th>Type</th>
              <th>Internal (Payarc) ID</th>
              <th>PayPal ID</th>
              <th>Status</th>
              <th>Customer name</th>
              <th>Customer Email</th>
              <th>
                <a (click)="setSorting('created_at')">Transaction date
                  <i class="fa fa-thin" [ngClass]="orderBy === 'created_at' ? stylesortBy : 'fa-angle-down'"></i>
                </a>
              </th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="loadFlag">
              <tr class="loader">
                <td colspan="7">
                  <div class="loader-container">
                    <img class="table-loader" src="../../../../assets/images/loading.svg">
                  </div>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="!loadFlag && transactionsList.data.length > 0">
              <tr *ngFor="let record of transactionsList.data" class="cursor" [routerLink]="redirectToDetails()" [queryParams]="{id: record.id}">
                <td>
                  <a data-th="Amount" [innerHTML]="record.amount ? ((highlight(record.amount | currency:(record.currency || 'USD'):'symbol':'1.2-2')) + ' ' + (record.currency || 'USD')) : '--'"></a>
                </td>
                <td data-th="Type">{{ record.type }}</td>
                <td data-th="Internal (Payarc) ID">{{ record.id }}</td>
                <td data-th="Paypal Id">
                  <a data-th="Paypal Id" [innerHTML]="record.paypal_id ? highlight(record.paypal_id) : '--'"></a>
                </td>
                <td data-th="Status">{{ record.status }}</td>
                <td data-th="Customer Name">{{ record.customer_name }}</td>
                <td data-th="Customer Email">{{ record.customer_email }}</td>
                <td data-th="Transaction Date">
                  <a>{{ record.created_at | date : 'MM/dd/yyyy hh:mm' }}</a>
                </td>
              </tr>
            </ng-container>
            <!--pagination start-->

            <!--pagination end-->
            </tbody>
          </table>
        </div>
        <div class="row m-0 pt-sm-4 pt-1 border-2" *ngIf="!loadFlag && transactionsList.data.length > 0">
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mb-5" *ngIf="metadata['total']">
                <span class="paginate">
                  {{ 1 + (metadata['current_page'] - 1) * limit }} -
                  <select [(ngModel)]="limit" (change)="setUrl()" class="page-limit"
                          *ngIf="metadata['current_page'] === 1">
                    <option *ngFor="let no of limitArray" [value]="no">{{
                        no
                      }}</option>
                  </select>
                  <span *ngIf="metadata['current_page'] !== 1">{{
                      metadata['count'] +
                      (metadata['current_page'] - 1) * limit
                    }}</span> &nbsp;of &nbsp;{{ metadata['total'] }}
                </span>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 text-lg-right text-left px-m-0 px-md-m-0">
            <ul class="list-inline"
                *ngIf="!loadFlag && transactionsList.data.length > 0 && objectKeys(metadata.links).length > 0">
              <li class="list-inline-item">
                <button type="button" class="btn btn-default btn_prenext pl-m-3" [disabled]="!metadata.links['previous']"
                        (click)="paginate( metadata.links['previous'])">
                  <i class="fa fa-angle-double-left" aria-hidden="true"></i> Previous
                </button>
              </li>
              <li class="list-inline-item" *ngFor="let number of numbers()">
                <div *ngIf="+number.toString() ">
                  <a class="page-link" *ngIf="metadata.links.next"
                     [ngClass]="{ 'paginate_active': metadata['current_page'] === number }"
                     (click)="nextpage(number, metadata.links.next)">{{number}}</a>
                  <a class="page-link"
                     *ngIf="metadata.links['previous'] && metadata['current_page'] > (metadata['total_pages'] - 1)"
                     [ngClass]="{ 'paginate_active': metadata['current_page'] === number }"
                     (click)="nextpage(number, metadata.links['previous'])">{{number}}</a>
                </div>
                <a class="page-link" *ngIf="!+number.toString()">{{number}}</a>
              </li>
              <li class="list-inline-item">
                <button type="button" class="btn btn-default btn_prenext px-m-0" [disabled]="!metadata.links['next']"
                        (click)="
                    paginate(metadata.links['next']) ">
                  Next <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-content export_content" *ngIf="showExport">
    <app-export-excel [exportExcel]="exportExcel" [serviceName]="exportData" [searchData]="searchText"></app-export-excel>
  </div>
</div>
